import get from 'transmute/get';
export const threadFromProps = (_state, props = {}) => get('thread', props);